module.exports = __webpack_public_path__ + "static/img/hkj7.27c0d0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/hkj7.jpg
// module id = 7/qH
// module chunks = 0